import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { SquareArrowOutUpRight } from "lucide-react"
import { NavLink, useLocation } from 'react-router-dom';
import Logo from '../../../assets/images/logo.png';
import Profile from '../../../assets/images/profile.png';
import classes from './mobileHeader.module.css';
import ProfileMenu from './profileMenu/profileMenu';
import { changeLanguage } from "../../../store/actions/index";

const MobileHeader = (props) => {
  const location = useLocation();
  let languageList = [
    {
      'id': 1,
      'display_value': 'EN',
      'name': 'English',
      'dir': 'ltr',
      'lang': 'en'
    },
    {
      'id': 0,
      'display_value': 'AR',
      'name': 'العربية',
      'dir': 'rtl',
      'lang': 'ar'
    }
  ]
  let navigationLinks = [
    {
      "id": 1,
      "name_en": "HOME",
      "name_ar": "الرئيسية",
      "slug": "",
      "type": "static",
      "value": "/",
      "target": "_self",
      "parameters": null,
      "enabled": true,
      "data": null,
      "icon": "",
      "children": []
    },
    {
      "id": 2,
      "name_en": "WHAT'S NEW",
      "name_ar": "جديدنا",
      "slug": "whats-new",
      "type": "static",
      "value": "/whats-new",
      "target": "_self",
      "parameters": null,
      "enabled": true,
      "data": null,
      "icon": "",
      "children": []
    },
    {
      "id": 3,
      "name_en": "ABOUT US",
      "name_ar": "من نحن",
      "slug": "about-us",
      "type": "static",
      "value": "/about-us",
      "target": "_self",
      "parameters": null,
      "enabled": true,
      "data": null,
      "icon": "",
      "children": []
    },
    {
      "id": 4,
      "name_en": "ACADEMY",
      "name_ar": "الأكاديمية",
      "slug": "academy",
      "type": "static",
      "value": "/academy",
      "target": "_self",
      "parameters": null,
      "enabled": true,
      "data": null,
      "icon": "",
      "children": []
    },
    {
      "id": 5,
      "name_en": "CAMPS",
      "name_ar": "المخيمات",
      "slug": "camps",
      "type": "static",
      "value": null,
      "target": "_self",
      "parameters": null,
      "enabled": true,
      "data": null,
      "icon": "",
      "children": [
        {
          "id": 51,
          "name_en": "SUMMER CAMP",
          "name_ar": "المخيم الصيفي",
          "slug": "camps/summer-camp",
          "type": "static",
          "value": "/camps/summer-camp",
          "target": "_self",
          "parameters": null,
          "enabled": true,
          "data": null,
          "icon": "",
          "children": []
        },
        {
          "id": 52,
          "name_en": "WINTER CAMP",
          "name_ar": "المخيم الشتوي",
          "slug": "camps/winter-camp",
          "type": "static",
          "value": "/camps/winter-camp",
          "target": "_self",
          "parameters": null,
          "enabled": true,
          "data": null,
          "icon": "",
          "children": []
        },
        {
          "id": 53,
          "name_en": "FOOTBALL CAMP",
          "name_ar": "مخيم كرة القدم",
          "slug": "camps/football-camp",
          "type": "static",
          "value": "/camps/football-camp",
          "target": "_self",
          "parameters": null,
          "enabled": true,
          "data": null,
          "icon": "",
          "children": []
        }
      ]
    },
    {
      "id": 6,
      "name_en": "ACTIVITIES",
      "name_ar": "النشاطات",
      "slug": "activities",
      "type": "static",
      "value": null,
      "target": "_self",
      "parameters": null,
      "enabled": true,
      "data": null,
      "icon": "",
      "children": [
        {
          "id": 61,
          "name_en": "BIRTHDAYS",
          "name_ar": "أعياد الميلاد",
          "slug": "activities/birthdays",
          "type": "static",
          "value": "/activities/birthdays",
          "target": "_self",
          "parameters": null,
          "enabled": true,
          "data": null,
          "icon": "",
          "children": []
        },
        {
          "id": 62,
          "name_en": "TEAM BUILDING",
          "name_ar": "بناء الفريق",
          "slug": "activities/team-building",
          "type": "static",
          "value": "/activities/team-building",
          "target": "_self",
          "parameters": null,
          "enabled": true,
          "data": null,
          "icon": "",
          "children": []
        },
        {
          "id": 63,
          "name_en": "EVENTS",
          "name_ar": "الأحداث",
          "slug": "activities/events",
          "type": "static",
          "value": "/activities/events",
          "target": "_self",
          "parameters": null,
          "enabled": true,
          "data": null,
          "icon": "",
          "children": []
        }
      ]
    },
    {
      "id": 7,
      "name_en": "TOURNAMENTS",
      "name_ar": "البطولات",
      "slug": "tournaments",
      "type": "static",
      "value": "/tournaments",
      "target": "_self",
      "parameters": null,
      "enabled": true,
      "data": null,
      "icon": "",
      "children": []
    },
    {
      "id": 8,
      "name_en": "CONTACT US",
      "name_ar": "اتصل بنا",
      "slug": "contact-us",
      "type": "static",
      "value": "/contact-us",
      "target": "_self",
      "parameters": null,
      "enabled": true,
      "data": null,
      "icon": "",
      "children": []
    },
    {
      "id": 9,
      "name_en": "FRANCHISE",
      "name_ar": "امتياز",
      "slug": "franchise",
      "type": "static",
      "value": "/franchise",
      "target": "_self",
      "parameters": null,
      "enabled": true,
      "data": null,
      "icon": "",
      "children": []
    },
    /*{
      "id": 10,
      "name_en": "ETIHAD CLUB",
      "name_ar": "نادي الاتحاد",
      "slug": "etihad-club",
      "type": "static",
      "value": "#",
      "target": "_self",
      "parameters": null,
      "enabled": true,
      "data": null,
      "icon": "",
      "children": []
    },
    {
      "id": 11,
      "name_en": "KIDS AREA",
      "name_ar": "نادي الأطفال",
      "slug": "kids-area",
      "type": "static",
      "value": "#",
      "target": "_self",
      "parameters": null,
      "enabled": true,
      "data": null,
      "icon": "",
      "children": []
    },*/
  ]
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [subMenuOpen, setSubMenuOpen] = useState(null);
  const [selectedLanguage, setSelectedLanguage] = useState(() => {
    const languageId = parseInt(localStorage.getItem('language')) || 1;
    return languageList.find(item => item.id === languageId) || languageList[0];
  });
  const [alternativeLanguage, setAlternativeLanguage] = useState(() => {
    const languageId = parseInt(localStorage.getItem('language')) || 1;
    return languageList.find(item => item.id !== languageId) || languageList[1];
  });
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [profileImg, setProfileImg] = useState(Profile);
  const translations = {
    login: {
      en: 'LOGIN',
      ar: 'تسجيل الدخول'
    }
  };
  useEffect(() => {
    if (selectedLanguage) {
      document.documentElement.dir = selectedLanguage.dir;
      document.documentElement.lang = selectedLanguage.lang;
    }
    setProfileImg(props.userData?.basic_info?.avatar ? props.userData?.basic_info?.avatar : Profile);
  }, [selectedLanguage]);
  useEffect(() => {
    setProfileImg(props.userData?.basic_info?.avatar ? props.userData?.basic_info?.avatar : Profile);
  }, [props.userData]);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const toggleMenuClasses = [classes.OpenMenu];
  if (isMenuOpen) toggleMenuClasses.push(classes.CloseMenu);
  const handleMenuClicked = (link) => {
    setSubMenuOpen(subMenuOpen === link.slug ? null : link.slug);
    link.children.length === 0 && setIsMenuOpen(false);
  };
  const toggleProfileOrLoginClicked = () => {
    setIsMenuOpen(false);
    setShowProfileMenu(true);
  }
  const handleLanguageClicked = () => {
    setIsMenuOpen(false);
    props.onLanguageChange(alternativeLanguage.id);
    document.documentElement.dir = alternativeLanguage.dir;   // Change the direction of the app (LTR or RTL)
    document.documentElement.lang = alternativeLanguage.lang; // Change the lang attribute of the app (en or ar)
    setSelectedLanguage(alternativeLanguage);
    setAlternativeLanguage(languageList.filter((item) => item.id !== parseInt(localStorage.getItem('language')))[0])
  }
  return (
    <div className={classes.Container}>
      <header className={classes.Header}>
        <div className={classes.LeftMenu}>
          <div onClick={toggleMenu} className={toggleMenuClasses.join(" ")}>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <NavLink to='/' className={classes.LogoContainer} onClick={() => setIsMenuOpen(false)}>
            <img
              src={Logo}
              alt="Logo"
            />
          </NavLink>
        </div>
        <div className={classes.RightMenu}>
          <button className={classes.Language} onClick={handleLanguageClicked}>
            {alternativeLanguage.name}
          </button>
          <div className={classes.Border}></div>
          {props.isAuthenticated ? (
            <div className={classes.ProfileContainer} onClick={toggleProfileOrLoginClicked}>
              <img
                src={profileImg}
                alt="Profile"
              />
            </div>
          ) : (
            <NavLink
              to='/login'
              className={classes.LogInButton}
              onClick={() => setIsMenuOpen(false)}
            >
              {parseInt(localStorage.getItem('language')) === 1 ? translations.login.en : translations.login.ar}
            </NavLink>
          )}
        </div>
      </header>
      {isMenuOpen && (
        <div className={[classes.SideMenuContainer, isMenuOpen ? classes.SideMenuContainerOpen : classes.SideMenuContainerClose].join(" ")}>
          <div className={classes.BlueBorder}>
            <div className={classes.WhiteBorder}>
              <div>
                <nav className={classes.NavigationLinks}>
                  {navigationLinks.map((link, i) => {
                    const isChildActive = link.children.some(child => location.pathname === child.value);
                    return (<NavLink
                      key={link.id}
                      to={link.value}
                      onClick={() => handleMenuClicked(link)}
                      className={({ isActive }) => {
                        return (`${isActive && link.value ? classes.Active : isChildActive ? classes.WithChildActive : ''} ${classes.NavLink} ${i !== navigationLinks.length - 2 ? classes.WithBorder : ''}`)
                      }}
                    >
                      <div>
                        <div className={classes.Link}>{parseInt(localStorage.getItem('language')) === 1 ? link.name_en : link.name_ar} {(i === navigationLinks.length - 2 || i === navigationLinks.length - 1)
                          && <SquareArrowOutUpRight className={classes.ShareIcon} />}
                          {link.children.length > 0 && <span className={`${classes.ArrowDown} ${subMenuOpen === link.slug && classes.ArrowUp}`}></span>}</div>
                        {subMenuOpen === link.slug && (
                          <div className={classes.SubMenuDropdown}>
                            <ul>
                              {link.children.map((child, i) =>
                                <li key={child.id}><NavLink
                                  to={child.value}
                                  onClick={() => handleMenuClicked(child)}
                                  className={({ isActive }) => (isActive && child.value ? classes.Active : '')}
                                >
                                  {parseInt(localStorage.getItem('language')) === 1 ? child.name_en : child.name_ar}
                                </NavLink></li>
                              )}
                            </ul>
                          </div>
                        )}
                      </div></NavLink>
                  )})}
                </nav>
              </div>
            </div>
          </div>
        </div>
      )}
      {showProfileMenu && <ProfileMenu showProfileMenu
        setShowProfileMenu={() => setShowProfileMenu()}
        onLogout={() => props.onLogout()}
        width={props.width}
        navigate={props.navigate}
        user={props.userData}
        profileImg={profileImg}
      />}
    </div>
  )
}

const mapDispatchToProps = dispatch => {
  return {
    onLanguageChange: (id) => dispatch(changeLanguage(id)),
  };
};

export default connect(null, mapDispatchToProps)(MobileHeader);